import { useEffect, useState, useCallback } from "react";

export type Audience = "owner" | "broker";

const STORAGE_KEY = "pd_audience";
const EVENT_NAME = "audience-change";

function readAudience(): Audience {
  if (typeof window === "undefined") return "broker";
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === "owner" ? "owner" : "broker";
}

export function useAudience() {
  const [audience, setAudienceState] = useState<Audience>(() => readAudience());

  useEffect(() => {
    const handler = () => setAudienceState(readAudience());
    window.addEventListener(EVENT_NAME, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(EVENT_NAME, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const setAudience = useCallback((next: Audience) => {
    window.localStorage.setItem(STORAGE_KEY, next);
    window.dispatchEvent(new Event(EVENT_NAME));
  }, []);

  return { audience, setAudience };
}